import ConfigFactory from './ConfigFactory';
import { createConfigModule } from '@framework/config/DI/createConfigModule';

export const configModule = createConfigModule(ConfigFactory);
